import { render, staticRenderFns } from "./clipper-basic.vue?vue&type=template&id=5129d3cb&scoped=true&"
import script from "./clipper-basic.vue?vue&type=script&lang=js&"
export * from "./clipper-basic.vue?vue&type=script&lang=js&"
import style0 from "./clipper-basic.vue?vue&type=style&index=0&id=5129d3cb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../common/temp/node_modules/.pnpm/vue-loader@15.10.0_68125b3067bc9264b7f5e63a32c23d52/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5129d3cb",
  null
  
)

export default component.exports